import React from 'react'
import {
  Label,
  Form,
  Button,
} from 'semantic-ui-react'
import Selector from './Selector.js'
import TypeEditorModal from './TypeEditorModal.js'
import TypePresetsModal from './TypePresetsModal.js';
import { cloneType } from './type.js'
import { coerceId } from './utils.js'

class SelectionSettingsForm extends React.Component {
  constructor(props) {
    super(props);
    // props: selection, selections, onSubmit, submitButtonName, typePresets
    this.state = {
      id: this.props.selection.id,
      idError: this.getIdError(this.props.selection.id),
      author: this.props.selection.author?this.props.selection.author:'',
      name: this.props.selection.name?this.props.selection.name:'',
      description: this.props.selection.description?this.props.selection.description:'',
      type: cloneType(this.props.selection.type?this.props.selection.type:this.props.typePresets[0]),
      typeEditorOpen: false,
      typePresetsOpen: false,
    }
  }
  getIdError = (id)=>{
    const existingSelection = this.props.selections.find(s=>s.id===id);
    return existingSelection&&existingSelection.id!==this.props.selection.id?"A selection with this ID already exists":undefined;
  }
  handleIdChange = (e, {value})=>{
    console.log("SelectionSettingsForm::handleIdChange()", e, value);
    value = coerceId(value);
    this.setState({
      id: value,
      idError: this.getIdError(value)
    });
  }
  handleChange = (e, { name, value })=>{
    console.log("SelectionSettingsForm::handleChange()", e, name, value);
    this.setState({ [name]: value });
  }
  handleTypeEditorOpen = ()=>{
    console.log("SelectionSettingsForm::handleTypeEditorOpen()");
    this.setState({ typeEditorOpen: true });
  }
  handleTypeEditorCloseUpdate = (type)=>{
    console.log("SelectionSettingsForm::handleTypeEditorCloseUpdate()");
    this.setState({
      typeEditorOpen: false,
      type: cloneType(type)
    });
  }
  handleTypeEditorCloseCancel = ()=>{
    console.log("SelectionSettingsForm::handleTypeEditorCancel()");
    this.setState({ typeEditorOpen: false });
  }
  handleTypePresetsOpen = ()=>{
    console.log("SelectionSettingsForm::handleTypePresetsOpen()");
    this.setState({ typePresetsOpen: true });
  }
  handleTypePresetsCloseUpdate = (type)=>{
    console.log("SelectionSettingsForm::handleTypePresetsCloseUpdate()");
    this.setState({
      typePresetsOpen: false,
      type: cloneType(type)
    });
  }
  handleTypePresetsCloseCancel = ()=>{
    console.log("SelectionSettingsForm::handleTypePresetsCancel()");
    this.setState({ typePresetsOpen: false });
  }
  handleSubmit = ()=>{
    console.log("SelectionSettingsForm::handleSubmit()");
    console.log("state:", this.state);
    const selection = {...this.props.selection};
    selection.id = this.state.id;
    selection.name = this.state.name;
    selection.author = this.state.author;
    selection.description = this.state.description;
    selection.type = cloneType(this.state.type);
    this.props.onSubmit(this.props.selection.id, selection);
  }
  render() {
    return (
      <div>
      <Form onSubmit={this.handleSubmit}>
        <Form.Group widths='equal'>
          <Form.Input
            fluid
            name='id'
            label='ID'
            error={!!this.state.idError}
            value={this.state.id}
            placeholder='Unique ID (e.g., abbreviation) of this selection'
            onChange={this.handleIdChange}
          />
          {
            this.state.idError?
              <Label basic color='red' pointing='left'>
                {this.state.idError}
              </Label>
            :<span></span>
          }
          <Form.Input
            fluid
            name='author'
            label='Author'
            value={this.state.author}
            placeholder='Who created this selection'
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Input
          fluid
          name='name'
          label='Name'
          value={this.state.name}
          placeholder='Full name of this selection'
          onChange={this.handleChange}
        />
        <Form.TextArea
          name='description'
          label='Description'
          value={this.state.description}
          placeholder='Description of this selection...'
          onChange={this.handleChange}
        />
        <div className='field'>
          <label>Type</label>
          <div>
            <Selector
              type={this.state.type}
              colorAll={true}
              onToggleItem={(eid,cid)=>{console.log("toggle", eid, cid)}}
            />
            <span>&nbsp;&nbsp;
              {
                this.state.type.map(e=>e.name).join(' | ')
              }
            </span>
            <Button compact floated='right' type='button' onClick={this.handleTypeEditorOpen}>Edit</Button>
            <Button compact floated='right' type='button' onClick={this.handleTypePresetsOpen}>Pick from Presents</Button>
          </div>
        </div>
        <Form.Button disabled={!!this.state.idError} color='orange'>{this.props.submitButtonName}</Form.Button>
      </Form>
      <TypeEditorModal
        type={this.state.type}
        open={this.state.typeEditorOpen}
        onSubmit={this.handleTypeEditorCloseUpdate}
        onCancel={this.handleTypeEditorCloseCancel}
      />
      <TypePresetsModal
        typePresets={this.props.typePresets}
        open={this.state.typePresetsOpen}
        onSubmit={this.handleTypePresetsCloseUpdate}
        onCancel={this.handleTypePresetsCloseCancel}
      />
      </div>
    );
  }
}

export default SelectionSettingsForm